import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button,
  Card,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Row,
  Table
} from 'reactstrap';

import styles from './style.module.scss';

import InfoIcon from '../../../assets/images/icons/info.svg';
import EditIcon from '../../../assets/images/icons/edit.svg';
import EditAllIcon from '../../../assets/images/icons/edit-all.svg';
import MoreIcon from '../../../assets/images/icons/more.svg';

import { IPlanningData, IPlanningPayload } from '../../../interfaces/strategic-plan-planning.interface';
import { IMeasureVisibility, IMeasureVisibilityPayload } from '../../../interfaces/common.interface';
import {
  CopyDataToPlan,
  GetStrategicPlanData,
  UpdateStrategicPlanData,
  FreezePlan,
  ImportTemplate
} from '../../../api-services/strategic-plan.api';
import { DownloadTemplate, UpdateMeasureVisibility } from '../../../api-services/common.api';

import SectionLoader from '../../../components/Common/loader/SectionLoader';
import InitialMessage from '../../../components/Common/initial-message/initial-message';
import NoDataFound from '../../../components/Common/no-data-found/no-data-found';
import InvalidData from '../../../components/Common/invalid-data/invalid-data';
import ActionCard from '../../../components/Footer/ActionCard';
import UnsavedDataModal from '../../../components/Common/Modals/UnsavedDataModal';
import SuccessModal from '../../../components/Common/Modals/SuccessModal';
import Tooltip from '../../../components/Common/tooltip/tooltip';

import {
  calculateMeasureTotal,
  calculateQuarterTotal,
  totalWeeksOfSelectedQuarter,
  checkIfAllQuartersArePast,
  getRatioSelectionOfPlanningGridForMonth,
  calculateActualMeasureTotal
} from './helper';
import {
  GetPlanId,
  getRatioSelectionOfPlanningGridForQuarter,
  IsNegative,
  NumberWithCommas, OneDecimalPlace,
} from '../../../helpers/Helpers';

import { UpdateEditRestriction } from '../../../store/action-restriction/actions';

interface OwnProps {
  history: any;
  isCallRequired: boolean;
  onLoadEnd: () => void;
  onUpdateStart: () => void;
  onUpdateEnd: () => void;
  onRunningEnd: () => void;
}

interface StateProps {
  history: any;
  isAllowed: boolean;
  filterData: any;
}

interface DispatchProps {
  UpdateEditRestriction: (isAllowed: boolean) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  isAutoLoad:boolean;
  isLoading: boolean;
  isExpanded: boolean;
  originalDataSource: IPlanningData;
  dataSource: IPlanningData;
  selectedColumn: string;
  initializeList: {
    label: string;
    value: string;
  }[];
  selectedInitialize: string;
  isMoreMenuOpened: boolean;
  isDownloadMenu: boolean;
  isEditable: boolean;
  isEditRestrictionAllowed: boolean;
  isVisibilityMenuOpened: boolean;
  measureVisibilityList: IMeasureVisibility;
  isModalOpened: boolean;
  isRunningModal: boolean;
  disableSave: boolean;
  successMessage: string;
}

class PlanningTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isAutoLoad: true,
      isLoading: false,
      isExpanded: true,
      originalDataSource: { columns: [], rows: [] },
      dataSource: { columns: [], rows: [] },
      selectedColumn: '',
      initializeList: [
        { label: 'Copy LY to Plan', value: 'LY' },
        { label: 'Copy LQ to Plan', value: 'LQ' },
        { label: 'Copy Foct to Plan', value: 'FT' },
        { label: 'Copy Sales Plan to Strategic Plan', value: 'ST' }
      ],
      selectedInitialize: '',
      isMoreMenuOpened: false,
      isDownloadMenu: false,
      isEditable: false,
      isEditRestrictionAllowed: false,
      isVisibilityMenuOpened: false,
      measureVisibilityList: { row: [] },
      isModalOpened: false,
      isRunningModal: false,
      disableSave: false,
      successMessage: '',
    };

    this.toggleMoreMenu = this.toggleMoreMenu.bind(this);
    this.toggleVisibilityMenu = this.toggleVisibilityMenu.bind(this);
    this.toggleDownloadMenu = this.toggleDownloadMenu.bind(this);
  }

  componentDidMount(): void {
    //this.getStrategicPlanData();
    this.setState({ isLoading: false }); 
    this.props.onLoadEnd();
  }

  componentDidUpdate(prevProps, prevState): void {
    if (!prevProps.isCallRequired && this.props.isCallRequired) {
      this.getStrategicPlanData();
    }
  }

  getStrategicPlanData(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
    };

    GetStrategicPlanData(params)
      .then((res: IPlanningData) => {
        this.setState({
          originalDataSource: !!res ? res : { columns: [], rows: [] },
          isLoading: false,isAutoLoad:false,
        }, () => {
          if (this.validateJSON()) {
            this.dataInit();
          }
          this.props.onLoadEnd();
          this.props.UpdateEditRestriction(false);
        });
      });
  }

  validateJSON(): boolean {
    const quarterLength = this.state.originalDataSource.columns.length;
    const weekLength = this.state.originalDataSource.columns.reduce((colInit, col) => {
      colInit += col.quarters.reduce((qInit, quarter) => {
        qInit += quarter.months.length;
        return qInit;
      }, 0);
      return colInit;
    }, 0);

    return this.state.originalDataSource.rows
      .reduce((rInit, row) => rInit && row.measures
        .reduce((mInit, measure) => mInit && measure.quarters.length === quarterLength && measure.quarters
          .reduce((qInit, quarter) => {
            qInit += quarter.months.length;
            return qInit;
          }, 0) === weekLength, true), true);
  }

  copyDataToPlan(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    CopyDataToPlan(this.state.selectedInitialize, params)
      .then(() => {
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
        this.setState({ selectedInitialize: '' });
      });
  }

  freezePlan(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    FreezePlan(params)
      .then(() => {
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
        this.setState({
                isModalOpened: true, 
                successMessage: 'Your changes have been successfully saved and are now frozen.'
              });
      });
  }

  importTemplate = (event): void => {
    let formData = new FormData();
    formData.append('file', event.target['files'][0], event.target['files'][0].name);

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    ImportTemplate(formData, params)
      .then(() => {
        this.props.onUpdateEnd();
      });
  };

  downloadTemplate(type: string): void {
    this.setState({ isLoading: true });

    const params = {
      type,
      planId: GetPlanId(this.props.history.location.pathname) || 1,
      userId: sessionStorage.getItem('userName')
    };

    DownloadTemplate(params).then((response) => {
      let filename = '';
      switch (type) {
        case 'units':
          filename = 'strategic_plan_units.xlsx';
          break;
        case 'revenue':
          filename = 'strategic_plan_revenue.xlsx';
          break;
        case 'frozen':
          filename = 'freeze_strategic_plan.xlsx';
          break;
      }
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        this.setState({ isLoading: false });
      });
    });
  }

  dataInit(): void {
    const data: IPlanningData = { ...this.state.originalDataSource };
    const dataSource: IPlanningData = {
      columns: data.columns.map((col) => {
        return {
          ...col,
          isExpanded: col.isExpanded,
        };
      }),
      rows: data.rows.map((row, rIdx: number) => {
        return {
          ...row,
          measures: row.measures.map((measure, mIdx: number) => {
            const mVal = calculateMeasureTotal(data.rows, rIdx, mIdx, row.name, measure.name);
            return {
              ...measure,
              value: mVal,
              oldVal: mVal,
              isPast: checkIfAllQuartersArePast(measure.quarters),
              quarters: measure.quarters.map((quarter, qIdx: number) => {
                const qVal = calculateQuarterTotal(data.rows, rIdx, mIdx, qIdx, row.name, measure.name);
                return {
                  ...quarter,
                  isExpanded: data.columns[qIdx].isExpanded,
                  isEdited: false,
                  isChanged: false,
                  isDisabled: false,
                  isError: IsNegative(calculateQuarterTotal(data.rows, rIdx, mIdx, qIdx, row.name, measure.name)),
                  value: qVal,
                  oldVal: qVal,
                  months: quarter.months.map((month) => {
                    const monthVal = measure.datatype === 'number'
                      ? Math.round(month.value)
                      : measure.datatype === 'percentage' ? OneDecimalPlace(month.value) : Math.round(month.value);
                    return {
                      ...month,
                      isError: IsNegative(month.value),
                      value: monthVal,
                      oldVal: monthVal,
                    };
                  })
                };
              })
            };
          })
        };
      })
    };

    const measureVisibilityList: IMeasureVisibility = {
      row: dataSource.rows.map((row) => {
        return {
          name: row.name,
          measures: row.measures.map((measure) => {
            return {
              name: measure.name,
              displayName: measure.displayName,
              isVisible: measure.isVisible,
              prevCheck: measure.isVisible
            };
          })
        };
      })
    };

    this.setState({ dataSource, measureVisibilityList });
  }

  toggleMoreMenu(): void {
    this.setState((prevState) => ({
      isMoreMenuOpened: !prevState.isMoreMenuOpened
    }));
  }

  toggleVisibilityMenu(): void {
    this.setState((prevState) => ({
      isVisibilityMenuOpened: !prevState.isVisibilityMenuOpened
    }));
  }

  toggleDownloadMenu(): void {
    this.setState((prevState) => ({
      isDownloadMenu: !prevState.isDownloadMenu
    }));
  }

  onExpandColumn(colIdx: number, isExpanded: boolean): void {
    const columns = [...this.state.dataSource.columns];
    const rows = [...this.state.dataSource.rows];

    columns.map((col, index) => col.isExpanded = (colIdx === index) ? !isExpanded : false);

    rows.forEach((row, rIdx: number) => {
      row.measures.forEach((measure, mIdx: number) => {
        columns.map((col, index) => {
          const qIdx = measure.quarters.findIndex((quarter) => quarter.name === columns[index].name);
          if (qIdx > -1 && index === colIdx) {
            rows[rIdx].measures[mIdx].quarters[qIdx].isExpanded = !rows[rIdx].measures[mIdx].quarters[qIdx].isExpanded;
          } else {
            rows[rIdx].measures[mIdx].quarters[qIdx].isExpanded = false;
          }
        });
      });
    });

    this.setState({ dataSource: this.state.dataSource });
  }

  isColumnExpanded(): boolean {
    return this.state.dataSource.columns.reduce((acc, col) => acc || col.isExpanded, false);
  }

  checkIfQuarterContainsZero(): boolean {
    const baseMeasureGroup = 'REVENUE ($)';
    const baseMeasure = 'Forecast Unconstrained $';
    const baseMeasureGroupIdx = this.state.dataSource.rows.findIndex((row) => row.name === baseMeasureGroup);

    if (baseMeasureGroupIdx > -1) {
      const baseMeasureIdx = this.state.dataSource.rows[baseMeasureGroupIdx].measures
        .findIndex((measure) => measure.name === baseMeasure);

      if (baseMeasureIdx > -1) {
        return this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx].quarters
          .reduce((acc, quarter) => acc || quarter.value === 0, false);
      }
    }

    return true;
  }

  onUpdateVisibilityCheck(rowIdx: number, measureIdx: number): void {
    this.state.measureVisibilityList.row[rowIdx].measures[measureIdx].isVisible =
      !this.state.measureVisibilityList.row[rowIdx].measures[measureIdx].isVisible;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].isVisible =
      !this.state.dataSource.rows[rowIdx].measures[measureIdx].isVisible;

    this.setState({
      dataSource: this.state.dataSource,
      measureVisibilityList: this.state.measureVisibilityList
    });
  }

  checkVisibilitySaveButton(): boolean {
    return this.state.measureVisibilityList.row
      .every((row) => row.measures
        .every((measure) => measure.isVisible === measure.prevCheck));
  }

  updateMeasureCalculation(rowArr, rowIdx: number, measureIdx: number, measureGroup: string, event): void {
    const baseMeasureGroup = 'REVENUE ($)';
    const baseMeasure = !this.checkIfQuarterContainsZero() ? 'Forecast Unconstrained $' : 'LY - Actuals $';
    const measureName = this.state.dataSource.rows[rowIdx].measures[measureIdx].name;

    const baseMeasureGroupIdx = this.state.dataSource.rows.findIndex((row) => row.name === baseMeasureGroup);

    const value = event.target.value;

    //Calculate Whole Margin% values
    const revenueIndex = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planSalesValueIndex = rowArr[revenueIndex].measures.findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
    const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');

    const marginPctWholeGrandTotal = (rowArr[marginIdx].measures[marginValueIdx].oldVal / rowArr[revenueIndex].measures[planSalesValueIndex].oldVal) * 100;
    const oldPlanSalesObj = JSON.parse(JSON.stringify(rowArr[revenueIndex].measures[planSalesValueIndex].quarters));
    const oldMarginValueObj = JSON.parse(JSON.stringify(rowArr[marginIdx].measures[marginValueIdx].quarters));

    this.state.dataSource.rows[rowIdx].measures[measureIdx].value = value;

    const isEdited = this.state.dataSource.rows[rowIdx].measures[measureIdx].value
      !== this.state.dataSource.rows[rowIdx].measures[measureIdx].oldVal;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].isEdited = isEdited;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].isChanged = true;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].isError = IsNegative(value);

    /*this.state.dataSource.rows
      .forEach((row, rIdx: number) => {
        row.measures
          .forEach((measure, mIdx: number) => {
            measure.isDisabled = (rIdx === rowIdx && mIdx !== measureIdx) ||
              (rIdx !== rowIdx && mIdx === measureIdx) ||
              (rIdx !== rowIdx && mIdx !== measureIdx);
            measure.quarters.forEach((quarter) => {
              quarter.isDisabled = (rIdx === rowIdx && mIdx !== measureIdx) ||
                (rIdx !== rowIdx && mIdx === measureIdx) ||
                (rIdx !== rowIdx && mIdx !== measureIdx);
            });
          });
      });*/

    if (['Plan ASP', 'Margin %'].indexOf(measureName) !== -1) {
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          quarter.value = parseFloat(value);
          quarter.isChanged = true;
        });
    } else {
      let baseMeasureIdx = -1;
      this.state.dataSource.rows.forEach((row) => {
        const idx = row.measures.findIndex((measure) => measure.name === baseMeasure);
        if (idx > -1) {
          baseMeasureIdx = idx;
        }
      });
      //Old GrandTotal Calculation
      /*if (baseMeasureIdx > -1) {
         this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
           .filter((quarter) => !quarter.isPast)
           .forEach((quarter, qIdx: number) => {
             const measureData = this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx];
             const baseMeasureQuarter = measureData.quarters[qIdx].value || 0;
             const baseMeasureTotal = measureData.value || 0;

             quarter.value = RoundingDown((baseMeasureQuarter / baseMeasureTotal) * (value || 0));
             quarter.isChanged = true;
           });
       } else {
         this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
           .forEach((quarter) => {
             quarter.value = parseFloat(
               Math.round((value || 0) / this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters.length).toString()
             );
             quarter.isChanged = true;
           });
       }

       const measureTotal = calculateMeasureTotalBasedOnQuarter(
         this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
           .filter((quarter) => !quarter.isPast)
       );

       let remainingQ = (value || 0) - measureTotal;

       if (remainingQ > 0) {
         this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
           .forEach((quarter, qIdx) => {
             if (!quarter.isPast && (quarter.value || quarter.value === 0)) {
               quarter.value += (remainingQ > 0 ? 1 : 0);
               remainingQ--;
               this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[qIdx].value = quarter.value;
             }
           });
       }*/

      //New GrandTotal Split Calculation
      if (measureName != 'Plan ASP $') {
        const pastQuarterTotal = this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
          .filter((quarter) => quarter.isPast)
          .reduce((pastVal, qaurter) => {
            pastVal += qaurter.value;
            return pastVal;
          }, 0);

        const editableQuarterTotal = this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
          .filter((quarter) => !quarter.isPast)
          .reduce((pastVal, qaurter) => {
            pastVal += qaurter.value;
            return pastVal;
          }, 0);

        if (value < pastQuarterTotal) {
          this.setState({ disableSave: true })
        } else {
          this.setState({ disableSave: false })
        }

        const remainingVal = value - pastQuarterTotal;
        this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
          .forEach((quarter, qIdx) => {
            if (!quarter.isPast && (quarter.value || quarter.value === 0)) {
              quarter.value = Math.round((quarter.value / editableQuarterTotal) * remainingVal);
              this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[qIdx].value = quarter.value;
              this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[qIdx].isChanged = true;
            }
          });
      }
    }

    //Units
    if (measureName === 'Plan / Quota U') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
      const planAspIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan ASP $');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
      const marginValueIdx = rowArr[marginIdx].measures
        .findIndex((measure) => measure.name === 'Margin $');
      const marginPctIdx = rowArr[marginIdx].measures
        .findIndex((measure) => measure.name === 'Margin %');

      const isPlanAspEdited = rowArr[rowNameIdx].measures[planAspIdx].isEdited;
      const isPlanValueEdited = rowArr[rowNameIdx].measures[planValueIdx].isEdited;
      const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

      rowArr[rowNameIdx].measures[planAspIdx].isDisabled = false;
      rowArr[rowNameIdx].measures[planValueIdx].isDisabled = false;

      rowArr[rowIdx].measures[measureIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      if (isPlanAspEdited) {
        rowArr[rowNameIdx].measures[planAspIdx].isDisabled = false;
        rowArr[rowNameIdx].measures[planValueIdx].isDisabled = true;

        const planUnitValue = parseFloat(rowArr[rowIdx].measures[measureIdx].value);
        const planAspValue = parseFloat(rowArr[rowNameIdx].measures[planAspIdx].value);
        rowArr[rowNameIdx].measures[planValueIdx].value = Math.round(planUnitValue * planAspValue);

        const baseMeasureIdx = this.state.dataSource.rows[rowIdx].measures
          .findIndex((measure) => measure.name === baseMeasure);

        this.state.dataSource.rows[rowNameIdx].measures[planValueIdx].quarters
          .forEach((quarter, qIdx: number) => {
            const measureData = this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx];
            const baseMeasureQuarter = measureData.quarters[qIdx].value || 0;
            const baseMeasureTotal = measureData.value || 0;

            quarter.value = Math.round((baseMeasureQuarter / baseMeasureTotal) * (planUnitValue * planAspValue));
            quarter.isChanged = true;
          });
        if (!isMarginValueEdited) {
          const planQuotaValue = rowArr[rowIdx].measures[measureIdx].value;
          rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planQuotaValue * (marginPctWholeGrandTotal / 100));
          rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter, qIdx: number) => {
            const planQuotaValueQ = rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value;
            const wholeMarginPctValueQ = (rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].oldVal / rowArr[rowNameIdx].measures[planValueIdx].quarters[qIdx].oldVal) * 100;
            quarter.value = Math.round(planQuotaValueQ * (wholeMarginPctValueQ / 100));
            quarter.isChanged = true;
          });
        }
      } else if (isPlanValueEdited) {
        const planUnitValue = parseFloat(rowArr[rowIdx].measures[measureIdx].value);
        const planAspValue = parseFloat(rowArr[rowNameIdx].measures[planAspIdx].value);
        rowArr[rowNameIdx].measures[planValueIdx].value = Math.round(planUnitValue * planAspValue);

        rowArr[rowNameIdx].measures[planAspIdx].isDisabled = true;
        rowArr[rowNameIdx].measures[planValueIdx].isDisabled = false;
      } else {
        const planUnitValue = parseFloat(rowArr[rowIdx].measures[measureIdx].value);
        // Hold ASP and Calculate Sales on Unit Edit ---->GrandTotal

        //Quarter total Sales
        rowArr[rowNameIdx].measures[planValueIdx].quarters.forEach((quarter, qIdx: number) => {
          const planQuotaValueQ = rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value;
          const planAspValueV = rowArr[rowNameIdx].measures[planAspIdx].quarters[qIdx].value;
          if (!quarter.isPast) {
            const wholeMarginPctValueQ = (rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].oldVal / rowArr[rowNameIdx].measures[planValueIdx].quarters[qIdx].oldVal) * 100;
            quarter.value = Math.round(planQuotaValueQ * planAspValueV);
            quarter.isChanged = true;
            //update margin$ Quarter
            rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].isChanged = true;
            rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].value = Math.round(quarter.value * (wholeMarginPctValueQ / 100));
          }
        });
        //GrandTotal Sales
        rowArr[rowNameIdx].measures[planValueIdx].value =
          rowArr[rowNameIdx].measures[planValueIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        // Recalculate ASP Value
        const salesTotalVal = rowArr[rowNameIdx].measures[planValueIdx].value;
        rowArr[rowNameIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitValue);

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons U') {
      const plVsFctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan vs Fcst Uncons U');
      const planUnitIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota U');
      const fctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Forecast Unconstrained U');

      const fctUValue = parseFloat(rowArr[rowIdx].measures[fctUIdx].value);
      const plVsFctUValue = parseFloat(rowArr[rowIdx].measures[plVsFctUIdx].value);

      rowArr[rowIdx].measures[planUnitIdx].value = plVsFctUValue + fctUValue;

      rowArr[rowIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsFctUIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LY U %') {
      const lyValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LY U %');
      const planUnitIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota U');
      const lyIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LY - Actuals U');
      const lyValue = parseFloat(rowArr[rowIdx].measures[lyIdx].value);
      const lyValuePercent = parseFloat(rowArr[rowIdx].measures[lyValuePercentIdx].value);
      if (lyValue != 0) {
        rowArr[rowIdx].measures[planUnitIdx].value = (1 + lyValuePercent / 100) * lyValue;
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[lyValuePercentIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LQ U %') {
      const lqValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LQ U %');
      const planUnitIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota U');
      const lqIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LQ - Actuals U');
      const lqValue = parseFloat(rowArr[rowIdx].measures[lqIdx].value);
      const lqValuePercent = parseFloat(rowArr[rowIdx].measures[lqValuePercentIdx].value);
      if (lqValue != 0) {
        rowArr[rowIdx].measures[planUnitIdx].value = (1 + lqValuePercent / 100) * lqValue;
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[lqValuePercentIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    //Revenue:
    if (measureName === 'Plan ASP $') {
      const unitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
      const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');

      const planUnitIdx = rowArr[unitIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota U');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
      const marginValueIdx = rowArr[marginIdx].measures
        .findIndex((measure) => measure.name === 'Margin $');
      const marginPctIdx = rowArr[marginIdx].measures
        .findIndex((measure) => measure.name === 'Margin %');

      const isPlanUnitEdited = rowArr[unitIdx].measures[planUnitIdx].isEdited;
      const isPlanValueEdited = rowArr[rowIdx].measures[planValueIdx].isEdited;
      const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

      rowArr[unitIdx].measures[planUnitIdx].isDisabled = false;
      rowArr[rowIdx].measures[planValueIdx].isDisabled = false;

      rowArr[rowIdx].measures[measureIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
        quarter.isChanged = false;
      });
      rowArr[rowIdx].measures[planValueIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
        quarter.isChanged = true;
      });

      if (isPlanUnitEdited) {
        rowArr[unitIdx].measures[planUnitIdx].isDisabled = false;
        rowArr[rowIdx].measures[planValueIdx].isDisabled = true;

        const planUnitValue = parseFloat(rowArr[unitIdx].measures[planUnitIdx].value);
        const planAspValue = parseFloat(rowArr[rowIdx].measures[measureIdx].value);
        rowArr[rowIdx].measures[planValueIdx].value = planUnitValue * planAspValue;

        const baseMeasureIdx = this.state.dataSource.rows[rowIdx].measures
          .findIndex((measure) => measure.name === baseMeasure);

        this.state.dataSource.rows[rowIdx].measures[planValueIdx].quarters
          .forEach((quarter, qIdx: number) => {
            const measureData = this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx];
            const baseMeasureQuarter = measureData.quarters[qIdx].value || 0;
            const baseMeasureTotal = measureData.value || 0;

            quarter.value = Math.round((baseMeasureQuarter / baseMeasureTotal) * (planUnitValue * planAspValue));
            quarter.isChanged = true;
          });

        if (!isMarginValueEdited) {
          const planQuotaValue = rowArr[rowIdx].measures[measureIdx].value;
          rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planQuotaValue * (marginPctWholeGrandTotal / 100));
          rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter, qIdx: number) => {
            const oldPlanQuotaValueQ = oldPlanSalesObj[qIdx].oldVal;
            const oldMarginValueQ = oldMarginValueObj[qIdx].oldVal;
            const marginPctWholeValueQ = (oldMarginValueQ / oldPlanQuotaValueQ) * 100;
            quarter.value = Math.round(planQuotaValue * (marginPctWholeValueQ / 100));
            quarter.isChanged = true;
          });
        }
      } else if (isPlanValueEdited) {
        rowArr[unitIdx].measures[planUnitIdx].isDisabled = true;
        rowArr[rowIdx].measures[planValueIdx].isDisabled = false;

        const planQuotaValue = parseFloat(rowArr[rowIdx].measures[planValueIdx].value);
        const planAspValue = parseFloat(rowArr[rowIdx].measures[measureIdx].value);
        rowArr[unitIdx].measures[planUnitIdx].value =
          planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;

        const baseMeasureIdx = this.state.dataSource.rows[rowIdx].measures
          .findIndex((measure) => measure.name === baseMeasure);

        this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters
          .forEach((quarter, qIdx: number) => {
            const measureData = this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx];
            const baseMeasureQuarter = measureData.quarters[qIdx].value || 0;
            const baseMeasureTotal = measureData.value || 0;

            quarter.value = Math.round((baseMeasureQuarter / baseMeasureTotal) * (planQuotaValue / planAspValue));
            quarter.isChanged = true;
            quarter.isDisabled = true;
          });
        rowArr[rowIdx].measures[measureIdx].quarters
          .forEach((quarter, qIdx) => {
            if (!quarter.isPast && (quarter.value || quarter.value === 0)) {
              const unitValQ = rowArr[unitIdx].measures[planUnitIdx].quarters[qIdx].value;
              const salesValQ = rowArr[rowIdx].measures[planValueIdx].quarters[qIdx].value;
              quarter.value = Math.round(salesValQ / unitValQ);
              rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value = quarter.value;
              rowArr[rowIdx].measures[measureIdx].quarters[qIdx].isChanged = true;
            }
          });
      } else {
        const planAspValue = parseFloat(rowArr[rowIdx].measures[measureIdx].value);
        const planUnitValue = parseFloat(rowArr[unitIdx].measures[planUnitIdx].value);
        rowArr[rowIdx].measures[planValueIdx].value =
          planAspValue !== 0 ? Math.round(planUnitValue * planAspValue) : 0;

        //Split Sales Grandtotal
        const pastQuarterTotal = rowArr[rowIdx].measures[planValueIdx].quarters
          .filter((quarter) => quarter.isPast)
          .reduce((pastVal, qaurter) => {
            pastVal += qaurter.value;
            return pastVal;
          }, 0);

        const editableQuarterTotal = rowArr[rowIdx].measures[planValueIdx].quarters
          .filter((quarter) => !quarter.isPast)
          .reduce((pastVal, qaurter) => {
            pastVal += qaurter.value;
            return pastVal;
          }, 0);

        const salesTotalVal = rowArr[rowIdx].measures[planValueIdx].value;
        if (salesTotalVal < pastQuarterTotal) {
          this.setState({ disableSave: true })
        } else {
          this.setState({ disableSave: false })

          const remainingVal = salesTotalVal - pastQuarterTotal;
          rowArr[rowIdx].measures[planValueIdx].quarters
            .forEach((quarter, qIdx) => {
              if (!quarter.isPast && (quarter.value || quarter.value === 0)) {
                quarter.value = Math.round((quarter.value / editableQuarterTotal) * remainingVal);
                rowArr[rowIdx].measures[planValueIdx].quarters[qIdx].value = quarter.value;
                rowArr[rowIdx].measures[planValueIdx].quarters[qIdx].isChanged = true;
              }
            });

          //Update Quarter ASP
          rowArr[rowIdx].measures[measureIdx].quarters
            .forEach((quarter, qIdx) => {
              if (!quarter.isPast && (quarter.value || quarter.value === 0)) {
                const unitValQ = rowArr[unitIdx].measures[planUnitIdx].quarters[qIdx].value;
                const salesValQ = rowArr[rowIdx].measures[planValueIdx].quarters[qIdx].value;
                quarter.value = Math.round(salesValQ / unitValQ);
                rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value = quarter.value;
                rowArr[rowIdx].measures[measureIdx].quarters[qIdx].isChanged = false;
                //update margin$ Quarter
                const oldPlanQuotaValueQ = oldPlanSalesObj[qIdx].oldVal;
                const oldMarginValueQ = oldMarginValueObj[qIdx].oldVal;
                const marginPctWholeValueQ = (oldMarginValueQ / oldPlanQuotaValueQ) * 100;
                rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].isChanged = true;
                rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].value = Math.round(salesValQ * (marginPctWholeValueQ / 100));
              }
            });
        }

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan / Quota Sales $') {
      const unitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
      const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');

      const planUnitIdx = rowArr[unitIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota U');
      const planAspIdx = rowArr[rowIdx].measures
        .findIndex((measure) => measure.name === 'Plan ASP $');
      const marginValueIdx = rowArr[marginIdx].measures
        .findIndex((measure) => measure.name === 'Margin $');
      const marginPctIdx = rowArr[marginIdx].measures
        .findIndex((measure) => measure.name === 'Margin %');

      const isPlanUnitEdited = rowArr[unitIdx].measures[planUnitIdx].isEdited;
      const isPlanAspEdited = rowArr[rowIdx].measures[planAspIdx].isEdited;
      const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

      rowArr[unitIdx].measures[planUnitIdx].isDisabled = false;
      rowArr[rowIdx].measures[planAspIdx].isDisabled = false;

      rowArr[rowIdx].measures[measureIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const planQuotaValue = rowArr[rowIdx].measures[measureIdx].value;
      const planUnitValue = rowArr[unitIdx].measures[planUnitIdx].value;
      const planAspValue = rowArr[rowIdx].measures[planAspIdx].value;

      if (!isMarginValueEdited) {
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planQuotaValue * (marginPctWholeGrandTotal / 100));
        rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter, qIdx: number) => {
          const oldPlanQuotaValueQ = oldPlanSalesObj[qIdx].oldVal;
          const oldMarginValueQ = oldMarginValueObj[qIdx].oldVal;
          const marginPctWholeValueQ = (oldMarginValueQ / oldPlanQuotaValueQ) * 100;
          const planQuotaValueQ = rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value;
          quarter.value = Math.round(planQuotaValueQ * (marginPctWholeValueQ / 100));
          quarter.isChanged = true;
        });
      }

      if (isPlanUnitEdited) {
        rowArr[rowIdx].measures[planAspIdx].value =
          planUnitValue !== 0 ? Math.round(planQuotaValue / planUnitValue) : 0;

        rowArr[unitIdx].measures[planUnitIdx].isDisabled = false;
        rowArr[rowIdx].measures[planAspIdx].isDisabled = true;
      } else if (isPlanAspEdited) {
        rowArr[unitIdx].measures[planUnitIdx].isDisabled = true;
        rowArr[rowIdx].measures[planAspIdx].isDisabled = false;

        rowArr[unitIdx].measures[planUnitIdx].value =
          planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;

        const baseMeasureIdx = this.state.dataSource.rows[rowIdx].measures
          .findIndex((measure) => measure.name === baseMeasure);

        this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters
          .forEach((quarter, qIdx: number) => {
            const measureData = this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx];
            const baseMeasureQuarter = measureData.quarters[qIdx].value || 0;
            const baseMeasureTotal = measureData.value || 0;

            quarter.value = Math.round((baseMeasureQuarter / baseMeasureTotal) * (planQuotaValue / planAspValue));
            quarter.isChanged = true;
            quarter.isDisabled = true;
          });
      } else {
        //Hold ASP and calculate Units on Sales Edit ----> GrandTotal
        //Quarter Total Unit
        rowArr[unitIdx].measures[planUnitIdx].quarters.forEach((quarter, qIdx: number) => {
          const planQuotaValueQ1 = rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value;
          const planASPValue1 = rowArr[rowIdx].measures[planAspIdx].quarters[qIdx].value;
          if (!quarter.isPast) {
            quarter.value = planASPValue1 !== 0 ? Math.round(planQuotaValueQ1 / planASPValue1) : 0;
            quarter.isChanged = true;
          }
        });

        //GrandTotal Units
        rowArr[unitIdx].measures[planUnitIdx].value =
          rowArr[unitIdx].measures[planUnitIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        // Recalculate ASP Value
        const salesTotalVal = rowArr[rowIdx].measures[measureIdx].value;
        const planUnitVal = rowArr[unitIdx].measures[planUnitIdx].value;
        rowArr[rowIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitVal);

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons $') {
      const plVsFctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan vs Fcst Uncons $');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
      const fctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Forecast Unconstrained $');
      const fctUValue = parseFloat(rowArr[rowIdx].measures[fctUIdx].value);
      const plVsFctUValue = parseFloat(rowArr[rowIdx].measures[plVsFctUIdx].value);
      rowArr[rowIdx].measures[planValueIdx].value = plVsFctUValue + fctUValue;

      rowArr[rowIdx].measures[planValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsFctUIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LY $ %') {
      const lyValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LY $ %');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
      const lyIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LY - Actuals $');
      const lyValue = parseFloat(rowArr[rowIdx].measures[lyIdx].value);
      const lyValuePercent = parseFloat(rowArr[rowIdx].measures[lyValuePercentIdx].value);
      if (lyValue != 0) {
        rowArr[rowIdx].measures[planValueIdx].value = (1 + lyValuePercent / 100) * lyValue;
      }

      rowArr[rowIdx].measures[planValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[lyValuePercentIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LQ $ %') {
      const lqValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LQ $ %');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
      const lqIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LQ - Actuals $');
      const lqValue = parseFloat(rowArr[rowIdx].measures[lqIdx].value);
      const lqValuePercent = parseFloat(rowArr[rowIdx].measures[lqValuePercentIdx].value);
      if (lqValue != 0) {
        rowArr[rowIdx].measures[planValueIdx].value = (1 + lqValuePercent / 100) * lqValue;
      }

      rowArr[rowIdx].measures[planValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[lqValuePercentIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

//Margin
    if (measureName === 'Margin %') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const marginIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin $');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
      const marginPercent = rowArr[rowIdx].measures[measureIdx].value;
      const planQuotaValue = rowArr[rowNameIdx].measures[planValueIdx].value;
      rowArr[rowIdx].measures[marginIdx].value = Math.round(planQuotaValue * (marginPercent / 100));

      rowArr[rowIdx].measures[marginIdx].isDisabled = true;
      rowArr[rowIdx].measures[marginIdx].quarters.forEach((quarter, qIdx: number) => {
        const planQuotaValueQ = rowArr[rowNameIdx].measures[planValueIdx].quarters[qIdx].value;
        const marginPctQ = rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value;
        quarter.value = Math.round(planQuotaValueQ * (marginPctQ / 100));
        quarter.isChanged = true;
        quarter.isDisabled = true;
      });

      rowArr[rowIdx].measures[measureIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
        quarter.isDisabled = true;
      });
    }

    if (measureName === 'PL vs LY Margin %') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

      const marginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin %');
      const plvslyMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LY Margin %');
      const lyMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LY Margin %');
      const marginIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin $');

      const plvslyMarginPercent = parseFloat(rowArr[rowIdx].measures[plvslyMarginPercentIdx].value);
      const lyMarginPercent = parseFloat(rowArr[rowIdx].measures[lyMarginPercentIdx].value);
      const planQuotaValue = parseFloat(rowArr[rowNameIdx].measures[planValueIdx].value);
      rowArr[rowIdx].measures[marginIdx].value = ((planQuotaValue) * (plvslyMarginPercent + lyMarginPercent)) / 100;
      rowArr[rowIdx].measures[marginPercentIdx].value = plvslyMarginPercent + lyMarginPercent;

      rowArr[rowIdx].measures[marginIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plvslyMarginPercentIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LQ Margin %') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

      const marginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin %');
      const plvslqMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LQ Margin %');
      const lqMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LQ Margin %');
      const marginIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin $');

      const plvslqMarginPercent = parseFloat(rowArr[rowIdx].measures[plvslqMarginPercentIdx].value);
      const lqMarginPercent = parseFloat(rowArr[rowIdx].measures[lqMarginPercentIdx].value);
      const planQuotaValue = parseFloat(rowArr[rowNameIdx].measures[planValueIdx].value);
      rowArr[rowIdx].measures[marginIdx].value = ((planQuotaValue) * (plvslqMarginPercent + lqMarginPercent)) / 100;
      rowArr[rowIdx].measures[marginPercentIdx].value = plvslqMarginPercent + lqMarginPercent;

      rowArr[rowIdx].measures[marginIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plvslqMarginPercentIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
      .filter((quarter) => !quarter.isPast)
      .forEach((quarter, qIdx) => {
        event.target.value = this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[qIdx].value;
        // this.updateQuarterCalculation(rowArr, rowIdx, measureIdx, qIdx, measureGroup, measureName, event)
      });

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateQuarterCalculation(
    rowArr,
    rowIdx: number,
    measureIdx: number,
    quarterIdx: number,
    measureGroup: string,
    measureName: string,
    event
  ): void {
    // const value = event.target.value !== '' ? parseFloat(TwoDecimalPlaceHandler(event.target.value)) : '';
    const value = event.target.value;

    //Calculate Whole Margin% values
    const revenueIndex = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planSalesValueIndex = rowArr[revenueIndex].measures.findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
    const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');

    const marginPctWholeValueQ = (rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].oldVal / rowArr[revenueIndex].measures[planSalesValueIndex].quarters[quarterIdx].oldVal) * 100;
    const marginPctWholeGrandTotal = (rowArr[marginIdx].measures[marginValueIdx].oldVal / rowArr[revenueIndex].measures[planSalesValueIndex].oldVal) * 100;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value = value;

    const isEdited = this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value
      !== this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].oldVal;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].isEdited = isEdited;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].isEdited = isEdited;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = true;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].isError = IsNegative(value);

    /*this.state.dataSource.rows
      .forEach((row, rIdx: number) => {
        row.measures
          .forEach((measure, mIdx: number) => {
            measure.isDisabled = (rIdx === rowIdx && mIdx !== measureIdx) ||
              (rIdx !== rowIdx && mIdx === measureIdx) ||
              (rIdx !== rowIdx && mIdx !== measureIdx);
            measure.quarters.forEach((quarter) => {
              quarter.isDisabled = (rIdx === rowIdx && mIdx !== measureIdx) ||
                (rIdx !== rowIdx && mIdx === measureIdx) ||
                (rIdx !== rowIdx && mIdx !== measureIdx);
            });
          });
      });*/

    this.state.dataSource.rows[rowIdx].measures[measureIdx].value =
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
      //.filter((quarter) => !quarter.isPast)
        .reduce((acc, quarter) => {
          acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
          return acc;
        }, 0);

    //Editing Based on Reverse Formula Calculation

    //UNIT Measures
    if (measureName === 'Plan / Quota U') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const planAspIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan ASP $');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

      const isPlanAspEdited = rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].isEdited;
      const isPlanValueEdited = rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].isEdited;

      rowArr[rowIdx].measures[measureIdx].isDisabled = true;
      rowArr[rowNameIdx].measures[planAspIdx].isDisabled = true;
      rowArr[rowNameIdx].measures[planValueIdx].isDisabled = true;

      const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
      const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');
      const marginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin %');

      if (isPlanAspEdited) {
        const planUnitValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value);
        const planAspValue = parseFloat(rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].value);
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].value =
          Math.round(planUnitValue * planAspValue);

        rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].isDisabled = false;
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].isDisabled = true;

        const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

        if (!isMarginValueEdited) {
          const planQuotaValue = rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].value;
          rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planQuotaValue * (marginPctWholeValueQ / 100));
        }
      } else if (isPlanValueEdited) {
        rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].isDisabled = true;
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].isDisabled = false;
      } else {
        //Hold ASP and Calculate Sales on Unit Edit ---->Quarter Level
        //Update Quarter Sales
        const planUnitValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value);
        const planAspValue = parseFloat(rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].value);
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].value =
          Math.round(planUnitValue * planAspValue);
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;

        //Update Sales GrandTotal
        rowArr[rowNameIdx].measures[planValueIdx].value =
          rowArr[rowNameIdx].measures[planValueIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        //Update Margin$ Value
        const planQuotaValue = rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planQuotaValue * (marginPctWholeValueQ / 100));
        //Update Margin$ Grandtotal
        const salesGrandTotal = rowArr[rowNameIdx].measures[planValueIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesGrandTotal * (marginPctWholeGrandTotal / 100));
        //Recalculate ASP
        const planUnitTotal = rowArr[rowIdx].measures[measureIdx].value;
        rowArr[rowNameIdx].measures[planAspIdx].value = Math.round(salesGrandTotal / planUnitTotal);
      }
    }

    if (measureName === 'Plan vs Fcst Uncons U') {
      const plVsFctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan vs Fcst Uncons U');
      const planUnitIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota U');
      const fctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Forecast Unconstrained U');
      const fctUValue = parseFloat(rowArr[rowIdx].measures[fctUIdx].quarters[quarterIdx].value);
      const plVsFctUValue = parseFloat(rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].value);
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].value = plVsFctUValue + fctUValue;

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY U %') {
      const lyValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LY U %');
      const planUnitIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota U');
      const lyIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LY - Actuals U');
      const lyValue = parseFloat(rowArr[rowIdx].measures[lyIdx].quarters[quarterIdx].value);
      const lyValuePercent = parseFloat(rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].value);
      if (lyValue != 0) {
        rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].value = (1 + lyValuePercent / 100) * lyValue;
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ U %') {
      const lqValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LQ U %');
      const planUnitIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota U');
      const lqIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LQ - Actuals U');
      const lqValue = parseFloat(rowArr[rowIdx].measures[lqIdx].quarters[quarterIdx].value);
      const lqValuePercent = parseFloat(rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].value);
      if (lqValue != 0) {
        rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].value = (1 + lqValuePercent / 100) * lqValue;
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].isChanged = false;
    }

    //Revenue:
    if (measureName === 'Plan ASP $') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'UNITS');

      const planUnitIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota U');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');

      const planQuotaValue = parseFloat(rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value);
      const planAspValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value);

      rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = true;

      const isPlanUnitEdited = rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isEdited;
      const isPlanValueEdited = rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isEdited;

      rowArr[rowIdx].measures[measureIdx].isDisabled = true;
      rowArr[rowNameIdx].measures[planUnitIdx].isDisabled = true;
      rowArr[rowIdx].measures[planValueIdx].isDisabled = true;

      const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
      const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');
      const marginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin %');

      if (isPlanUnitEdited) {
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
        rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;

        const planUnitValue = parseFloat(rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].value);
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value = (planUnitValue * planAspValue);

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = false;
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].isDisabled = true;

        const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

        if (!isMarginValueEdited) {
          const planQuotaValue = rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value;
          rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planQuotaValue * (marginPctWholeValueQ / 100));
        }

      } else if (isPlanValueEdited) {
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
        const planQuotaValue = parseFloat(rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value);
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].value = planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = true;
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].isDisabled = false;
      } else {
        //Hold Unit and Calculate Sales on ASP Edit---->Quarter Level
        const planUnitValue = rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].value;
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value = (planUnitValue * planAspValue);
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;
        //Update Sales GrandTotal
        rowArr[rowIdx].measures[planValueIdx].value =
          rowArr[rowIdx].measures[planValueIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        //Update Margin$
        const planQuotaValue = rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planQuotaValue * (marginPctWholeValueQ / 100));
        //Update Margin$ grandTotal
        const salesGrandTotal = rowArr[rowIdx].measures[planValueIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesGrandTotal * (marginPctWholeGrandTotal / 100));
        // Update ASP GrandTotal
        const planUnitGrandTotal = rowArr[rowNameIdx].measures[planUnitIdx].value
        const planAspIdx = rowArr[rowIdx].measures
          .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan ASP $');
        rowArr[rowIdx].measures[planAspIdx].value = Math.round(salesGrandTotal / planUnitGrandTotal);
      }
    }

    if (measureName === 'Plan / Quota Sales $') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'UNITS');

      const planUnitIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota U');
      const planAspIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan ASP $');

      const isPlanUnitEdited = rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isEdited;
      const isPlanAspEdited = rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].isEdited;

      rowArr[rowIdx].measures[measureIdx].isDisabled = true;
      rowArr[rowNameIdx].measures[planUnitIdx].isDisabled = true;
      rowArr[rowIdx].measures[planAspIdx].isDisabled = true;

      const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
      const marginValueIdx = rowArr[marginIdx].measures
        .findIndex((measure) => measure.name === 'Margin $');
      const marginPctIdx = rowArr[marginIdx].measures
        .findIndex((measure) => measure.name === 'Margin %');
      const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

      if (!isMarginValueEdited) {
        const planQuotaValue = rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planQuotaValue * (marginPctWholeValueQ / 100));
      }

      if (isPlanUnitEdited) {
        const planQuotaValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value);
        const planUnitValue = parseFloat(rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].value);
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].value =
          planUnitValue !== 0 ? Math.round(planQuotaValue / planUnitValue) : 0;

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = false;
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].isDisabled = true;
      } else if (isPlanAspEdited) {
        const planQuotaValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value);
        const planAspValue = parseFloat(rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].value);
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].value =
          planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = true;
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].isDisabled = false;

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      } else {
        //Hold ASP and Calculate Units on Sales Edit -->Quarter Level
        //Quarter unit
        const planQuotaValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value);
        const planAspValue = parseFloat(rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].value);
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].value =
          planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;

        //Plan Unit GrandTotal
        rowArr[rowNameIdx].measures[planUnitIdx].value =
          rowArr[rowNameIdx].measures[planUnitIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        //Recalculate ASP
        const salesTotalVal = rowArr[rowIdx].measures[measureIdx].value;
        const planUnitTotal = rowArr[rowNameIdx].measures[planUnitIdx].value;
        rowArr[rowIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitTotal);

        //Update Margin$ grandTotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons $') {
      const plVsFctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan vs Fcst Uncons $');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
      const fctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Forecast Unconstrained $');
      const fctUValue = parseFloat(rowArr[rowIdx].measures[fctUIdx].quarters[quarterIdx].value);
      const plVsFctUValue = parseFloat(rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].value);
      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value = plVsFctUValue + fctUValue;

      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY $ %') {
      const lyValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LY $ %');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
      const lyIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LY - Actuals $');
      const lyValue = parseFloat(rowArr[rowIdx].measures[lyIdx].quarters[quarterIdx].value);
      const lyValuePercent = parseFloat(rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].value);
      if (lyValue != 0) {
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value = (1 + lyValuePercent / 100) * lyValue;
      }

      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ $ %') {
      const lqValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LQ $ %');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
      const lqIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LQ - Actuals $');
      const lqValue = parseFloat(rowArr[rowIdx].measures[lqIdx].quarters[quarterIdx].value);
      const lqValuePercent = parseFloat(rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].value);
      if (lqValue != 0) {
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value = (1 + lqValuePercent / 100) * lqValue;
      }

      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].isChanged = false;
    }

//Margin
    if (measureName === 'Margin %') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const marginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin %');
      const marginIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin $');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
      const marginPercent = parseFloat(rowArr[rowIdx].measures[marginPercentIdx].quarters[quarterIdx].value);
      const planQuotaValue = parseFloat(rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].value);
      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].value = marginPercent * planQuotaValue / 100;

      this.state.dataSource.rows[rowIdx].measures[measureIdx].value =
        (
          this.state.dataSource.rows[rowIdx].measures[measureIdx].value /
          this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters.length
        );

      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[marginPercentIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY Margin %') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

      const marginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin %');
      const plvslyMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LY Margin %');
      const lyMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LY Margin %');
      const marginIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin $');

      const plvslyMarginPercent = parseFloat(rowArr[rowIdx].measures[plvslyMarginPercentIdx].quarters[quarterIdx].value);
      const lyMarginPercent = parseFloat(rowArr[rowIdx].measures[lyMarginPercentIdx].quarters[quarterIdx].value);
      const planQuotaValue = parseFloat(rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].value);
      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].value = ((planQuotaValue) * (plvslyMarginPercent + lyMarginPercent)) / 100;
      rowArr[rowIdx].measures[marginPercentIdx].quarters[quarterIdx].value = plvslyMarginPercent + lyMarginPercent;

      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plvslyMarginPercentIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ Margin %') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

      const marginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin %');
      const plvslqMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LQ Margin %');
      const lqMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LQ Margin %');
      const marginIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin $');

      const plvslqMarginPercent = parseFloat(rowArr[rowIdx].measures[plvslqMarginPercentIdx].quarters[quarterIdx].value);
      const lqMarginPercent = parseFloat(rowArr[rowIdx].measures[lqMarginPercentIdx].quarters[quarterIdx].value);
      const planQuotaValue = parseFloat(rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].value);
      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].value = ((planQuotaValue) * (plvslqMarginPercent + lqMarginPercent)) / 100;
      rowArr[rowIdx].measures[marginPercentIdx].quarters[quarterIdx].value = plvslqMarginPercent + lqMarginPercent;

      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plvslqMarginPercentIdx].quarters[quarterIdx].isChanged = false;
    }

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateWeekCalculation(
    rowArr,
    rowIdx: number,
    measureIdx: number,
    quarterIdx: number,
    monthIdx: number,
    measureGroup,
    event
  ): void {
    // const value = units !== '' ? parseFloat(event.target.value) : parseInt(event.target.value);
    const value = event.target.value;
    const measureName = this.state.dataSource.rows[rowIdx].measures[measureIdx].name;

    //Calculate Whole Margin% value
    const revenueIndex = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planSalesValueIndex = rowArr[revenueIndex].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
    const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');

    const marginPctWholeValueW = (rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].months[monthIdx].oldVal / rowArr[revenueIndex].measures[planSalesValueIndex].quarters[quarterIdx].months[monthIdx].oldVal) * 100;
    const marginPctWholeValueQ = (rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].oldVal / rowArr[revenueIndex].measures[planSalesValueIndex].quarters[quarterIdx].oldVal) * 100;
    const marginPctWholeGrandTotal = (rowArr[marginIdx].measures[marginValueIdx].oldVal / rowArr[revenueIndex].measures[planSalesValueIndex].oldVal) * 100;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value = value;

    const isEdited = this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value
      !== this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].oldVal;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].isEdited = isEdited;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].isEdited = isEdited;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = true;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].isError = IsNegative(value);

    /*this.state.dataSource.rows
      .forEach((row, rIdx: number) => {
        row.measures
          .forEach((measure, mIdx: number) => {
            measure.quarters.forEach((quarter) => {
              quarter.months.forEach((month, wIdx: number) => {
                month.isDisabled = (rIdx !== rowIdx && mIdx !== measureIdx && wIdx === monthIdx) ||
                  (rIdx === rowIdx && mIdx !== measureIdx && wIdx === monthIdx) ||
                  (rIdx !== rowIdx && mIdx !== measureIdx && wIdx !== monthIdx) ||
                  (rIdx !== rowIdx && mIdx === measureIdx && wIdx === monthIdx) ||
                  (rIdx !== rowIdx && mIdx === measureIdx && wIdx !== monthIdx) ||
                  (rIdx === rowIdx && mIdx !== measureIdx && wIdx !== monthIdx);
              })
            });
          });
      });*/

    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value =
      Math.round(this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].months
        .reduce((acc, month) => {
          acc += typeof month.value === 'string' ? parseFloat(month.value) : month.value;
          return acc;
        }, 0));

    this.state.dataSource.rows[rowIdx].measures[measureIdx].value =
      Math.round(this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters.reduce((acc, quarter) => {
        acc += quarter.value;
        return acc;
      }, 0));

    if (measureName.includes('Plan ASP')) {
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value =
        (
          this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value /
          this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].months.length
        );
      this.state.dataSource.rows[rowIdx].measures[measureIdx].value =
        (
          this.state.dataSource.rows[rowIdx].measures[measureIdx].value /
          this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters.length
        );
    }

//UNIT Measures
    if (measureName === 'Plan / Quota U') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const planAspIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan ASP $');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

      const isPlanAspEdited = rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].isEdited;
      const isPlanValueEdited = rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isEdited;

      const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
      const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');
      const marginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin %');

      if (isPlanAspEdited) {
        const planUnitValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value);
        const planAspValue = parseFloat(rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].value);
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value =
          Math.round(planUnitValue * planAspValue);

        rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].isDisabled = false;
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isDisabled = true;

        const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

        if (!isMarginValueEdited) {
          const planQuotaValue = rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value;
          rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].months[monthIdx].value = Math.round(planQuotaValue * (marginPctWholeValueW / 100));
        }

        this.state.dataSource.rows[rowIdx].measures[planAspIdx].quarters[quarterIdx].isChanged = false;
      } else if (isPlanValueEdited) {
        const planUnitValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value);
        const planQuotaValue = parseFloat(rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value);
        rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].value =
          Math.round(planQuotaValue / planUnitValue);

        rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].isDisabled = true;
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isDisabled = false;
      } else {
        const planUnitValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value);
        //Hold ASP and Calculate sales on Unit Edit - Week Level
        const planAspValue = parseFloat(rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].value);
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value =
          Math.round(planUnitValue * planAspValue);
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;

        //Sales Quarter GrandTotal
        rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].value =
          Math.round(rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months
            .reduce((acc, month) => {
              acc += typeof month.value === 'string' ? parseFloat(month.value) : month.value;
              return acc;
            }, 0));

        //Final Sales GrandTotal
        rowArr[rowNameIdx].measures[planValueIdx].value =
          Math.round(rowArr[rowNameIdx].measures[planValueIdx].quarters.reduce((acc, quarter) => {
            acc += quarter.value;
            return acc;
          }, 0));

        //Recalculate ASP QuarterTotal
        const salesTotalValQ = rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].value;
        const planUnitTotalQ = rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value;
        rowArr[rowNameIdx].measures[planAspIdx].quarters[quarterIdx].value = Math.round(salesTotalValQ / planUnitTotalQ);

        //Recalculate ASP GrandTotal
        const salesTotalVal = rowArr[rowNameIdx].measures[planValueIdx].value;
        const planUnitTotal = rowArr[rowIdx].measures[measureIdx].value
        rowArr[rowNameIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitTotal);

        //Update Margin$ week
        const planQuotaWeek = rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].months[monthIdx].value = Math.round(planQuotaWeek * (marginPctWholeValueW / 100));
        //Update Margin$ Quarter
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(salesTotalValQ * (marginPctWholeValueQ / 100));
        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons U') {
      const plVsFctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan vs Fcst Uncons U');
      const planUnitIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota U');
      const fctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Forecast Unconstrained U');
      const fctUValue = parseFloat(rowArr[rowIdx].measures[fctUIdx].quarters[quarterIdx].months[monthIdx].value);
      const plVsFctUValue = parseFloat(rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].months[monthIdx].value);
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].value = plVsFctUValue + fctUValue;

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].months[monthIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY U %') {
      const lyValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LY U %');
      const planUnitIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota U');
      const lyIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LY - Actuals U');
      const lyValue = parseFloat(rowArr[rowIdx].measures[lyIdx].quarters[quarterIdx].months[monthIdx].value);
      const lyValuePercent = parseFloat(rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].months[monthIdx].value);
      if (lyValue != 0) {
        rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].value = (1 + lyValuePercent / 100) * lyValue;
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].months[monthIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ U %') {
      const lqValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LQ U %');
      const planUnitIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota U');
      const lqIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LQ - Actuals U');
      const lqValue = parseFloat(rowArr[rowIdx].measures[lqIdx].quarters[quarterIdx].months[monthIdx].value);
      const lqValuePercent = parseFloat(rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].months[monthIdx].value);
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].value = (1 + lqValuePercent / 100) * lqValue;

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].months[monthIdx].isChanged = false;
    }

//Revenue
    if (measureName === 'Plan ASP $') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'UNITS');

      const planUnitIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota U');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');

      const planQuotaValue = parseFloat(rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value);
      const planAspValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value);

      //rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      //rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;

      const isPlanUnitEdited = rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isEdited;
      const isPlanValueEdited = rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isEdited;

      const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
      const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');
      const marginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin %');

      if (isPlanUnitEdited) {
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;

        const planUnitValue = parseFloat(rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].value);
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value = (planUnitValue * planAspValue);

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isDisabled = false;
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isDisabled = true;

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = false;
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isDisabled = true;

        const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

        if (!isMarginValueEdited) {
          const planQuotaValue = rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value;
          rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].months[monthIdx].value = Math.round(planQuotaValue * (marginPctWholeValueW / 100));
        }

        this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;
      } else if (isPlanValueEdited) {
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].value =
          planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isDisabled = true;
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isDisabled = false;

        this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;
        this.state.dataSource.rows[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      } else {
        //Hold Unit and Calculate Sales on ASP Edit ---->Week Calculation
        const planUnitValue = rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].value;
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value = Math.round(planUnitValue * planAspValue);
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
        rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;

        //Sales Quarter GrandTotal
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value =
          Math.round(rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months
            .reduce((acc, month) => {
              acc += typeof month.value === 'string' ? parseFloat(month.value) : month.value;
              return acc;
            }, 0));

        //Final Sales GrandTotal
        rowArr[rowIdx].measures[planValueIdx].value =
          Math.round(rowArr[rowIdx].measures[planValueIdx].quarters.reduce((acc, quarter) => {
            acc += quarter.value;
            return acc;
          }, 0));

        // Update ASP GrandTotal
        const salesGrandTotal = rowArr[rowIdx].measures[planValueIdx].value;
        const planUnitGrandTotal = rowArr[rowNameIdx].measures[planUnitIdx].value
        const planAspIdx = rowArr[rowIdx].measures
          .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan ASP $');
        rowArr[rowIdx].measures[planAspIdx].value = Math.round(salesGrandTotal / planUnitGrandTotal);

        // Update ASP Quarter GrandTotal
        const salesGrandTotalQ = rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].value;
        const planUnitGrandTotalQ = rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].value;
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].value = Math.round(salesGrandTotalQ / planUnitGrandTotalQ);

        //Update Margin$ Week
        const planQuotaWeek = rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].months[monthIdx].value = Math.round(planQuotaWeek * (marginPctWholeValueW / 100));

        //Update Margin$ Quarter
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(salesGrandTotalQ * (marginPctWholeValueQ / 100));

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesGrandTotal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan / Quota Sales $') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'UNITS');

      const planUnitIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota U');
      const planAspIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan ASP $');

      const isPlanUnitEdited = rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isEdited;
      const isPlanAspEdited = rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].isEdited;

      const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');
      const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');
      const marginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin %');
      const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

      if (!isMarginValueEdited) {
        const planQuotaValue = rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].months[monthIdx].value = Math.round(planQuotaValue * (marginPctWholeValueW / 100));
      }

      if (isPlanUnitEdited) {
        const planQuotaValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value);
        const planUnitValue = parseFloat(rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].value);
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].value =
          planUnitValue !== 0 ? Math.round(planQuotaValue / planUnitValue) : 0;

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isDisabled = false;
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].isDisabled = true;
      } else if (isPlanAspEdited) {
        const planQuotaValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value);
        const planAspValue = parseFloat(rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].value);
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].value =
          planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isDisabled = true;
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].isDisabled = false;

        this.state.dataSource.rows[rowIdx].measures[planAspIdx].quarters[quarterIdx].isChanged = false;
        this.state.dataSource.rows[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      } else {
        // Hold ASP and Calculate Units on Sales Edit ---> Week Calculation
        const planQuotaValue = parseFloat(rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].months[monthIdx].value);
        const planAspValue = parseFloat(rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].months[monthIdx].value);
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].value =
          planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;

        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
        //Hold ASP and Update Quarter GrandTotal of Units
        rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].value =
          Math.round(rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].months
            .reduce((acc, month) => {
              acc += typeof month.value === 'string' ? parseFloat(month.value) : month.value;
              return acc;
            }, 0));

        //Update Final GrandTotal of Units
        rowArr[rowNameIdx].measures[planUnitIdx].value =
          Math.round(rowArr[rowNameIdx].measures[planUnitIdx].quarters.reduce((acc, quarter) => {
            acc += quarter.value;
            return acc;
          }, 0));

        //Recalculate ASP QuarterTotal
        const salesTotalValQ = rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value;
        const planUnitTotalQ = rowArr[rowNameIdx].measures[planUnitIdx].quarters[quarterIdx].value
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].value = Math.round(salesTotalValQ / planUnitTotalQ);
        //Recalculate ASP GrandTotal
        const salesTotalVal = rowArr[rowIdx].measures[measureIdx].value;
        const planUnitTotal = rowArr[rowNameIdx].measures[planUnitIdx].value
        rowArr[rowIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitTotal);

        //Update Margin$ Quarter
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(salesTotalValQ * (marginPctWholeValueQ / 100));
        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons $') {
      const plVsFctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan vs Fcst Uncons $');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
      const fctUIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Forecast Unconstrained $');

      const fctUValue = parseFloat(rowArr[rowIdx].measures[fctUIdx].quarters[quarterIdx].months[monthIdx].value);
      const plVsFctUValue = parseFloat(rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].months[monthIdx].value);
      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value = plVsFctUValue + fctUValue;

      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsFctUIdx].quarters[quarterIdx].months[monthIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY $ %') {
      const lyValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LY $ %');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
      const lyIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LY - Actuals $');
      const lyValue = parseFloat(rowArr[rowIdx].measures[lyIdx].quarters[quarterIdx].months[monthIdx].value);
      const lyValuePercent = parseFloat(rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].months[monthIdx].value);
      if (lyValue != 0) {
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value = (1 + lyValuePercent / 100) * lyValue;
      }

      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[lyValuePercentIdx].quarters[quarterIdx].months[monthIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ $ %') {
      const lqValuePercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LQ $ %');
      const planValueIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
      const lqIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LQ - Actuals $');
      const lqValue = parseFloat(rowArr[rowIdx].measures[lqIdx].quarters[quarterIdx].months[monthIdx].value);
      const lqValuePercent = parseFloat(rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].months[monthIdx].value);
      if (lqValue != 0) {
        rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value = (1 + lqValuePercent / 100) * lqValue;
      }

      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[lqValuePercentIdx].quarters[quarterIdx].months[monthIdx].isChanged = false;
    }

//Margin
    if (measureName === 'Margin %') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const marginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin %');
      const marginIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin $');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
      const marginPercent = parseFloat(rowArr[rowIdx].measures[marginPercentIdx].quarters[quarterIdx].months[monthIdx].value);
      const planQuotaValue = parseFloat(rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value);
      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].months[monthIdx].value = marginPercent * planQuotaValue / 100;

      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[marginPercentIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[marginPercentIdx].quarters[quarterIdx].months[monthIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY Margin %') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

      const marginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin %');
      const plvslyMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LY Margin %');
      const lyMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LY Margin %');
      const marginIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin $');

      const plvslyMarginPercent = parseFloat(rowArr[rowIdx].measures[plvslyMarginPercentIdx].quarters[quarterIdx].months[monthIdx].value);
      const lyMarginPercent = parseFloat(rowArr[rowIdx].measures[lyMarginPercentIdx].quarters[quarterIdx].months[monthIdx].value);
      const planQuotaValue = parseFloat(rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value);
      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].months[monthIdx].value = ((planQuotaValue) * (plvslyMarginPercent + lyMarginPercent)) / 100;
      rowArr[rowIdx].measures[marginPercentIdx].quarters[quarterIdx].months[monthIdx].value = plvslyMarginPercent + lyMarginPercent;

      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[plvslyMarginPercentIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plvslyMarginPercentIdx].quarters[quarterIdx].months[monthIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ Margin %') {
      const rowNameIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
      const planValueIdx = rowArr[rowNameIdx].measures
        .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

      const marginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin %');
      const plvslqMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'PL vs LQ Margin %');
      const lqMarginPercentIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'LQ Margin %');
      const marginIdx = rowArr[rowIdx].measures
        .findIndex((measure) => rowArr[rowIdx].name === measureGroup && measure.name === 'Margin $');

      const plvslqMarginPercent = parseFloat(rowArr[rowIdx].measures[plvslqMarginPercentIdx].quarters[quarterIdx].months[monthIdx].value);
      const lqMarginPercent = parseFloat(rowArr[rowIdx].measures[lqMarginPercentIdx].quarters[quarterIdx].months[monthIdx].value);
      const planQuotaValue = parseFloat(rowArr[rowNameIdx].measures[planValueIdx].quarters[quarterIdx].months[monthIdx].value);
      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].months[monthIdx].value = ((planQuotaValue) * (plvslqMarginPercent + lqMarginPercent)) / 100;
      rowArr[rowIdx].measures[marginPercentIdx].quarters[quarterIdx].months[monthIdx].value = plvslqMarginPercent + lqMarginPercent;

      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[marginIdx].quarters[quarterIdx].months[monthIdx].isChanged = true;
      rowArr[rowIdx].measures[plvslqMarginPercentIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plvslqMarginPercentIdx].quarters[quarterIdx].months[monthIdx].isChanged = false;
    }

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateStrategicPlanData(isFreezeRequired: boolean): void {
    const payload: IPlanningPayload = { row: [] };

    const isQuarterExpanded = !!this.state.dataSource.rows
      .filter((row) => !!row.measures
        .filter((measure) => !!measure.quarters
          .filter((quarter) => quarter.isExpanded).length).length).length;

    payload.row = this.state.dataSource.rows
      .filter((row) => row.measures
        .filter((measure) => !!measure.quarters
          .filter((quarter) => quarter.isChanged).length).length)
      .map((row) => {
        return {
          name: row.name,
          measures: row.measures
            .filter((measure) => !!measure.quarters
              .filter((quarter) => quarter.isChanged).length)
            .map((measure) => {
              return {
                name: measure.name,
                quarters: measure.quarters
                  .filter((quarter) => quarter.isChanged)
                  .map((quarter, qIdx: number) => {
                    const quarterPayload: any = {
                      name: quarter.name
                    };
                    if (isQuarterExpanded) {
                      quarterPayload.weeks = quarter.months
                        .filter((month) => month.isChanged)
                        .map((month, mIdx: number) => {
                          return {
                            name: month.name,
                            value: month.value,
                            ratioSelection:
                              getRatioSelectionOfPlanningGridForMonth(this.state.dataSource.rows, qIdx, mIdx, month.oldVal),
                          };
                        });
                    } else {
                      quarterPayload.value = quarter.value;
                      quarterPayload.ratioSelection =
                        getRatioSelectionOfPlanningGridForQuarter(this.state.dataSource.rows, qIdx, quarter.oldVal,true);
                    }
                    return quarterPayload;
                  })
              };
            })
        };
      });

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    UpdateStrategicPlanData(payload, params)
      .then((res) => {
        if (!!res && res != 'running') {
          this.setState({
            isEditable: false
          }, () => {
            if (isFreezeRequired) {
              this.freezePlan();
            } else {
              this.props.onUpdateEnd();
              this.props.UpdateEditRestriction(false);
            }
          });
        } else if (!!res && res === 'running') {
          this.setState({
                  isRunningModal: true, 
                  successMessage: 'Another user using same filters for saving, Please try after sometime'
                });
          this.props.onLoadEnd();
          this.props.onRunningEnd();
          this.setState({
            isEditable: false
          }, () => {
            this.dataInit();
          });
          this.props.UpdateEditRestriction(false);
        }
      });
  }

  updateMeasureVisibility(): void {
    const payload: IMeasureVisibilityPayload = {
      visibility: this.state.measureVisibilityList.row
        .flatMap((row) => row.measures
          .map((measure) => ({
              name: measure.name,
              isVisible: measure.isVisible
            })
          )
        )
    };
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    UpdateMeasureVisibility(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({
            isLoading: true,
            isModalOpened: true
          }, () => {
            this.getStrategicPlanData();
          });
        }
      });
  }

  saveButtonValidity(): boolean {
    const { rows } = this.state.dataSource;
    return rows.length > 0 && rows.some(row => row.measures.some(measure => measure.isEdited));
  }

  saveFreezeButtonValidity(): boolean {
    const { rows } = this.state.dataSource;

    if (rows.length === 0) {
      return false;
    }

    const unitIdx = rows.findIndex((row) => row.name === 'UNITS');
    const planUnitIdx = rows[unitIdx].measures.findIndex((measure) => measure.name === 'Plan / Quota U');
    const total = calculateActualMeasureTotal(rows[unitIdx].measures[planUnitIdx].quarters);

    return total > 0;
  }

  disableActionBtn(): boolean {
    return this.state.originalDataSource.columns.some(q => q.past);
  }

  render(): React.ReactNode {
    if (this.state.isLoading) {
      return <SectionLoader/>;
    }

    if (this.state.isAutoLoad) {
      return <InitialMessage/>;
    }

    if (this.state.originalDataSource.rows.length === 0) {
      return <NoDataFound/>;
    }

    if (!this.validateJSON()) {
      return <InvalidData/>;
    }

    const headerSection = <Card className="section-header-card">
      <Row>
        <Col md={7} className="align-self-center">

          <Row className="align-items-center">
            <Col md={6}>

              <div className="d-flex">
                <p className="table-title">{this.props.filterData.level} -
                  <span className="sub-title"> {this.props.filterData.products}</span>
                </p>
                <img src={InfoIcon} alt="info-icon" className="cursor-pointer"/>
              </div>

            </Col>

            <Col md={5}>

              <div className="custom-form-container">
                <label htmlFor={'initialize'} className="custom-form-label">Initialize</label>
                <select
                  id="initialize"
                  className="custom-drop-down-field custom-select-width"
                  disabled={this.disableActionBtn()}
                  onChange={(e) => {
                    this.props.isAllowed
                      ? this.setState({ isEditRestrictionAllowed: true })
                      : this.setState({ isEditRestrictionAllowed: false });
                    this.setState({
                      selectedInitialize: e.target.value
                    }, () => {
                      ['LY', 'LQ', 'FT', 'ST'].indexOf(this.state.selectedInitialize) !== -1 &&
                      this.copyDataToPlan();
                    });
                  }}
                  value={this.state.selectedInitialize}
                >
                  <option value="">Select</option>
                  {
                    this.state.initializeList.map((initialize, initializeIdx) => (
                      <option
                        key={initializeIdx}
                        value={initialize.value}
                      >
                        {initialize.label}
                      </option>
                    ))
                  }
                </select>
              </div>

            </Col>
          </Row>

        </Col>

        <Col
          md={{ size: 2, offset: 3 }}
          className="align-self-center"
        >

          <div className="d-flex justify-content-end">
            <Dropdown
              isOpen={this.state.isVisibilityMenuOpened}
              toggle={this.toggleVisibilityMenu}
              className="d-inline-block user-dropdown"
            >
              <Tooltip
                content={'Measure Visibility Setting'}
                direction={'top'}
              >
                <DropdownToggle tag="button" className="btn action-btn waves-effect p-0">
                  <i className="ri-list-settings-line font-size-18"/>
                </DropdownToggle>
              </Tooltip>

              <DropdownMenu className="custom-dropdown-menu dropdown-menu-end">
                <React.Fragment>
                  <Row className="dropdown-menu-box">
                    {
                      this.state.measureVisibilityList.row.map((row, rIdx: number) => (
                        <Col md={4} key={rIdx}>
                          <p className="header-dropdown-label">{row.name}</p>
                          {
                            row.measures.map((measure, mIdx: number) => (
                              <React.Fragment key={mIdx}>
                                <DropdownItem
                                  toggle={false}
                                  className={`${(measure.isVisible !== measure.prevCheck) && 'dropdown-item-changed'}`}
                                >
                                  <div className="d-flex align-items-center">
                                    <Input
                                      id={rIdx + ' ' + mIdx}
                                      type="checkbox"
                                      checked={measure.isVisible}
                                      onChange={() => this.onUpdateVisibilityCheck(rIdx, mIdx)}
                                      className="me-2"
                                    />
                                    <Label for={rIdx + ' ' + mIdx} className="cursor-pointer mb-0">
                                      {measure.displayName}
                                    </Label>
                                  </div>
                                </DropdownItem>
                                {
                                  row.measures.length - 1 !== mIdx &&
                                  <DropdownItem divider/>
                                }
                              </React.Fragment>
                            ))
                          }
                        </Col>
                      ))
                    }
                  </Row>
                  <div className="py-1 text-right">
                    <Button
                      color={'primary'}
                      disabled={this.checkVisibilitySaveButton()}
                      className="btn btn-sm btn-primary ms-3 mx-3"
                      onClick={() => this.updateMeasureVisibility()}
                    >
                      Save
                    </Button>
                  </div>
                </React.Fragment>
              </DropdownMenu>
            </Dropdown>

            <Tooltip
              content={'Edit All'}
              direction={'top'}
            >
              <div
                className="action-btn"
                onClick={() => {
                  if (this.props.isAllowed) {
                    this.setState({ isEditRestrictionAllowed: true });
                  } else {
                    this.props.history.replace({
                      pathname: '/strategic-plan/edit-all',
                      search: '?filter=true',          //  HO--I180
                      state: { fromStrategicPlan: true } 
                    });
                  }
                }}
              >
                <img
                  src={EditAllIcon}
                  alt="edit-icon"
                  height={'24px'}
                  className="edit-icon-position"
                />
              </div>
            </Tooltip>

            <Tooltip
              content={'Edit measures'}
              direction={'top'}
            >
              <div
                className="action-btn"
                onClick={() => {
                  this.props.isAllowed
                    ? this.setState({ isEditRestrictionAllowed: true })
                    : this.setState({ isEditable: true })
                }}
              >
                <img src={EditIcon} alt="edit-icon" className="edit-icon-position"/>
              </div>
            </Tooltip>

            {/*<div className="d-flex align-items-center cursor-pointer mx-4">
              <div className="event-box"/>
              <span className="action-label">Events</span>
            </div>*/}

            <Dropdown
              isOpen={this.state.isMoreMenuOpened}
              toggle={this.toggleMoreMenu}
              className="d-inline-block user-dropdown"
            >
              <Tooltip content={'More'} direction={'top'}>
                <DropdownToggle tag="button" className="btn action-btn waves-effect p-0">
                  <img src={MoreIcon} alt="more-icon"/>
                </DropdownToggle>
              </Tooltip>

              <DropdownMenu className="dropdown-menu-end">
                <div className="position-relative">
                  <DropdownItem
                    disabled={this.disableActionBtn()}
                    onClick={() => {
                      if (this.props.isAllowed) {
                        this.setState({ isEditRestrictionAllowed: true });
                      }
                    }}
                  >
                    Import
                  </DropdownItem>
                  <input
                    type="file"
                    accept=".csv,
                      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                      application/vnd.ms-excel"
                    disabled={this.disableActionBtn()}
                    onChange={(e) => {
                      this.importTemplate(e);
                      this.toggleMoreMenu();
                    }}
                  />
                </div>
                <DropdownItem divider/>

                <Dropdown
                  isOpen={this.state.isDownloadMenu}
                  toggle={this.toggleDownloadMenu}
                  className="d-inline-block user-dropdown"
                  direction="end"
                >
                  <DropdownToggle className={styles['dropdown-toggle']}>Download Template</DropdownToggle>
                  <DropdownMenu id={styles['downloadDropdown']}>
                    <DropdownItem onClick={() => this.downloadTemplate('units')}>Units</DropdownItem>
                    <DropdownItem onClick={() => this.downloadTemplate('revenue')}>Revenue</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <DropdownItem divider/>

                {/*<DropdownItem
                  onClick={() => {
                    this.freezePlan();
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    }
                  }}
                >Freeze Plan</DropdownItem>
                <DropdownItem divider/>*/}

                {/*<DropdownItem
                  onClick={() => {
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    }
                  }}
                >SKU Level Plan</DropdownItem>
                <DropdownItem divider/>*/}

                {/*<DropdownItem
                  onClick={() => {
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    } else {
                      this.props.history.replace('/strategic-plan/edit-all?filter');
                    }
                  }}
                >Edit All</DropdownItem>*/}

                <DropdownItem
                  onClick={() => {
                    this.downloadTemplate('frozen');
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    }
                  }}
                >Download Freeze Plan</DropdownItem>
                <DropdownItem divider/>

              </DropdownMenu>
            </Dropdown>

            <i className={`ri-arrow-${this.state.isExpanded ? 'up' : 'down'}-s-line ps-1 cursor-pointer`}
               style={{ fontSize: '22px' }}
               onClick={() => this.setState({ isExpanded: !this.state.isExpanded })}
            />
          </div>

        </Col>
      </Row>
    </Card>;
    const bodySection = <div className="table-responsive table-outline custom-table sticky-table">
      <Table className="mb-0">
        <thead>
        <tr>
          <th className="dark-bg-cell"/>
          {
            this.state.dataSource.columns.map((col, colIdx: number) => (
              <th
                key={colIdx}
                colSpan={col.isExpanded ? totalWeeksOfSelectedQuarter(this.state.dataSource.columns, colIdx) : 1}
              >
                <span
                  className="toggle-col"
                >
                {col.name}
                  <i
                    className={`${col.isExpanded ? 'ri-checkbox-indeterminate-fill' : 'ri-add-box-fill'} ms-sm-2`}
                    onClick={() => {
                      this.props.isAllowed
                        ? this.setState({ isEditRestrictionAllowed: true })
                        : this.onExpandColumn(colIdx, col.isExpanded);
                    }}
                  />
                </span>
              </th>
            ))
          }
          <th
            className="table-header-text dark-bg-cell v-middle"
            style={{ whiteSpace: 'nowrap' }}
          >
            Grand Total
          </th>
        </tr>
        {
          this.isColumnExpanded() &&
          <React.Fragment>
            <tr>
              <th className="dark-bg-cell"/>
              {
                this.state.dataSource.columns.map((col, cIdx: number) => (
                  <React.Fragment key={cIdx}>
                    {
                      col.isExpanded
                        ? col.quarters.map((quarter, qIdx: number) => (
                          <th
                            key={qIdx}
                            colSpan={col.isExpanded ? quarter.months.length : 1}
                            className="text-center"
                          >
                            {quarter.name}
                          </th>
                        ))
                        : <th/>
                    }
                  </React.Fragment>
                ))
              }
              <th/>
              <th className="dark-bg-cell"/>
            </tr>
            <tr>
              <th className="dark-bg-cell"/>
              {
                this.state.dataSource.columns.map((col, cIdx: number) => (
                  <React.Fragment key={cIdx}>
                    {
                      col.isExpanded
                        ? col.quarters.map((quarter, qIdx: number) => (
                          <React.Fragment key={qIdx}>
                            {
                              col.isExpanded &&
                              quarter.months.map((month, mIdx: number) => (
                                <th
                                  key={mIdx}
                                  className="text-center"
                                >
                                  {month}
                                </th>
                              ))
                            }
                            {
                              col.quarters.length - 1 === qIdx &&
                              <th className="dark-bg-cell text-center">Total</th>
                            }
                          </React.Fragment>
                        ))
                        : <th/>
                    }
                  </React.Fragment>
                ))
              }
              <th className="dark-bg-cell"/>
            </tr>
          </React.Fragment>
        }
        </thead>

        <tbody>
        {
          this.state.dataSource.rows.map((row, rIdx: number) => (
            <React.Fragment key={rIdx}>
              <tr className="table-header-outline bg-white">
                <td className="table-header-text text-right">{row.name}</td>
                {
                  this.state.dataSource.columns.map((col, cIdx: number) => (
                    <React.Fragment key={cIdx}>
                      {
                        col.isExpanded
                          ? col.quarters.map((quarter, qIdx: number) => (
                            <React.Fragment key={qIdx}>
                              {
                                col.isExpanded &&
                                quarter.months.map((month, mIdx: number) => (
                                  <td key={mIdx}/>
                                ))
                              }
                              {
                                col.quarters.length - 1 === qIdx && <td className="dark-bg-cell"/>
                              }
                            </React.Fragment>
                          ))
                          : <td/>
                      }
                    </React.Fragment>
                  ))
                }
                <td className="dark-bg-cell"/>
              </tr>
              {
                row.measures.map((measure, mIdx) => (
                  <React.Fragment key={mIdx}>
                    {
                      measure.isVisible &&
                      <tr>
                        <td className="table-data-text dark-bg-cell text-right">{measure.displayName}</td>
                        {
                          measure.quarters.map((quarter, qIdx) => (
                            <React.Fragment key={qIdx}>
                              {
                                !quarter.isExpanded
                                  ? <td className="text-right">
                                    {/*<span className={`${quarter.isError && 'text-danger'}`}>
                                        {measure.datatype === 'currency' && measure.symbol}
                                      </span>*/}
                                    {
                                      (measure.editable && this.state.isEditable && !this.isColumnExpanded() && !quarter.isPast)
                                        ? <input
                                          type="number"
                                          className={
                                            `${(quarter.isEdited)
                                              ? 'editable-input-new'
                                              : 'editable-input'}
                                            ${quarter.isDisabled && ' readonly-input'}
                                            ${quarter.isError && ' error-input'}`
                                          }
                                          readOnly={quarter.isDisabled}
                                          onChange={(e) => {
                                            this.updateQuarterCalculation(this.state.dataSource.rows, rIdx, mIdx, qIdx, row.name, measure.name, e);
                                          }}
                                          value={quarter.value}
                                        />
                                        : <span className={`${quarter.isError && 'text-danger'}`}>
                                            {NumberWithCommas(quarter.value)}
                                          </span>
                                    }
                                    {/*<span className={`${quarter.isError && 'text-danger'}`}>
                                      {measure.datatype === 'percentage' && '%'}
                                    </span>*/}
                                  </td>
                                  : quarter.months.map((month, wIdx: number) => (
                                    <React.Fragment key={wIdx}>
                                      <td className={`${month.isPast ? 'disabled-cell' : ''} text-right`}>
                                        {/*<span className={`${month.isError && 'text-danger'}`}>
                                          {measure.datatype === 'currency' && measure.symbol}
                                        </span>*/}
                                        {
                                          (measure.editable && this.state.isEditable && this.isColumnExpanded())
                                            ? <input
                                              type="number"
                                              className={
                                                `${(month.isEdited)
                                                  ? 'editable-input-new'
                                                  : 'editable-input'}
                                                  ${month.isDisabled && ' readonly-input'}
                                                  ${month.isError && ' error-input'}`
                                              }
                                              readOnly={month.isDisabled}
                                              onChange={(e) => {
                                                this.updateWeekCalculation(this.state.dataSource.rows, rIdx, mIdx, qIdx, wIdx, row.name, e);
                                              }}
                                              value={month.value}
                                            />
                                            : <span className={`${month.isError && 'text-danger'}`}>
                                                {NumberWithCommas(month.value)}
                                              </span>
                                        }
                                        {/*<span className={`${month.isError && 'text-danger'}`}>
                                          {measure.datatype === 'percentage' && '%'}
                                        </span>*/}
                                      </td>
                                      {
                                        quarter.months.length - 1 === wIdx &&
                                        <td className="dark-bg-cell text-right">
                                          <span className={`${quarter.isError && 'text-danger'}`}>
                                            {/*{measure.datatype === 'currency' && measure.symbol}*/}
                                            {NumberWithCommas(quarter.value || 0)}
                                            {/*{measure.datatype === 'percentage' && '%'}*/}
                                          </span>
                                        </td>
                                      }
                                    </React.Fragment>
                                  ))
                              }
                            </React.Fragment>
                          ))
                        }
                        <td className="dark-bg-cell text-right">
                          {/*<span className={`${measure.isError && 'text-danger'}`}>
                              {measure.datatype === 'currency' && measure.symbol}
                            </span>*/}
                          {
                            (measure.editable && this.state.isEditable && !this.isColumnExpanded() && !measure.isPast)
                              ? <input
                                type="number"
                                className={
                                  `${(measure.isEdited)
                                    ? 'editable-input-new'
                                    : 'editable-input'}
                                    ${measure.isDisabled && ' readonly-input'}
                                    ${measure.isError && ' error-input'}`
                                }
                                readOnly={measure.isDisabled}
                                onChange={(e) => {
                                  this.updateMeasureCalculation(this.state.dataSource.rows, rIdx, mIdx, row.name, e);
                                }}
                                value={measure.value}
                              />
                              : <span className={`${measure.isError && 'text-danger'}`}>
                                    {NumberWithCommas(measure.value || 0)}
                                  </span>
                          }
                          {/*<span className={`${measure.isError && 'text-danger'}`}>
                                {measure.datatype === 'percentage' && '%'}
                              </span>*/}
                        </td>
                      </tr>
                    }
                  </React.Fragment>
                ))
              }
            </React.Fragment>
          ))
        }
        </tbody>
      </Table>
    </div>;

    return (
      <React.Fragment>
        <div className="mb-2">
          {headerSection}
          {this.state.isExpanded && bodySection}
        </div>

        {
          this.state.isEditable &&
          <ActionCard
            onCancel={() => {
              this.setState({
                isEditable: false,
                disableSave: false
              }, () => {
                this.dataInit();
              });
              this.props.UpdateEditRestriction(false);
            }}
            onSave={() => this.updateStrategicPlanData(false)}
            onSaveAndFreeze={() => this.updateStrategicPlanData(true)}
            isSaveDisabled={!this.saveButtonValidity()}
            isSaveAndFreezeDisabled={!this.saveFreezeButtonValidity()}
          />
        }

        <UnsavedDataModal
          isOpen={this.state.isEditRestrictionAllowed}
          toggle={() => this.setState({ isEditRestrictionAllowed: !this.state.isEditRestrictionAllowed })}
          removeChanges={() => {
            this.props.UpdateEditRestriction(false);
            this.setState({
              isEditable: false,
              isEditRestrictionAllowed: false
            }, () => {
              this.dataInit();
            });
          }}
        />

        <SuccessModal
          isOpen={this.state.isModalOpened}
          toggle={() => this.setState({ isModalOpened: !this.state.isModalOpened })}
          message={'Measure visibility updated successfully !!!'}
        />
        <SuccessModal
          isOpen={this.state.isRunningModal}
          toggle={() => this.setState({ isRunningModal: !this.state.isRunningModal })}
          message={'Another user using same filters for saving, Please try after sometime'}
        />

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    ...state.EditRestriction,
    filterData: state.FilterData
  };
};

export default connect<StateProps, DispatchProps, OwnProps>
(mapStateToProps, {
  UpdateEditRestriction
})(withRouter(PlanningTable));
